<template>
  <div class="">
    <v-header ref="dudu"></v-header>
    <div class="beijngsd">
      <span></span>
      个人中心
      <span></span>
    </div>
    <div class="manpin">
      <div class="main centen container">
        <leftmenu ref="leftmenu"></leftmenu>
        <!-- 在class为main_r里面写页面就行 -->
        <div class="main_r">
          <div class="mainr_top">
            <img src="../images/geren16.png">安全设置
          </div>
          <ul class="form">
            <li>
              <label style="width: auto;">手机号绑定&nbsp;:</label>
              <label
                style="width: auto;margin-left: 30px; width: 100px;color: #29A7E1;text-align: left;">{{userInfo.userPhone==null?'未绑定':userInfo.userPhone}}</label>
              <label class="upbtn" @click="updatephone">{{userInfo.userPhone==null?'绑定手机':'更换手机'}}</label>
            </li>
            <li>
              <label style="width: auto;">密&nbsp;码&nbsp;设&nbsp;置&nbsp;:</label>
              <label style="width: auto;margin-left: 30px; width: 100px;color: #29A7E1;text-align: left;">已设置</label>
              <label class="upbtn" @click="updatepwd">修改密码</label>
            </li>
          </ul>
          <div class="mainr_bot">
            <div class="youxinxi">
              <label>填写说明</label>
              <figure>
                <img src="../../assets/gerenzhongxin/geren1.png">
                <figcaption>安全设置中的绑定手机号码请绑定用户常用手机号码</figcaption>
              </figure>
              <figure>
                <img src="../../assets/gerenzhongxin/geren2.png">
                <figcaption>绑定后手机号码可作为用户名登录</figcaption>
              </figure>
              <figure>
                <img src="../../assets/gerenzhongxin/geren3.png">
                <figcaption>考生所绑定手机号请确保可以正常接受短信息</figcaption>
              </figure>
              <figure>
                <img src="../../assets/gerenzhongxin/geren4.png">
                <figcaption>输入的新密码为考生帐号的新的登录密码，修改完成后，原密码自动作废，下次以安全设置中输入的新密码登录</figcaption>
              </figure>

            </div>
          </div>
        </div>

        <div class="tuichuden" v-if="show">
          <div class="annou">
            <h1>{{title}}</h1>
            <div>
              <ul class="form" v-if="step == 1">
                <li>
                  <label>手机号：</label>
                  <div class="shoujiinp">
                    <!-- <input v-model="oldphone" placeholder="请输入手机号" disabled/> -->
                    {{oldphone}}
                  </div>
                </li>
                <li>
                  <label>验证码：</label>
                  <div class="shoujiinp">
                    <input v-model="oldcode" placeholder="请输入验证码" @focus="codeerror=null" />
                    <button @click="sendMsg" type="primary" :class="[dusnhhwe == true ? 'duanxin':'duanxin2']"
                      :disabled="isDisabled">
                      <span v-if="!isDisabled">发送验证码</span>
                      <span v-if="isDisabled">{{time}}s后发送</span>
                    </button>
                    <span class="shangxia" v-if="codeerror!=null&&codeerror!=''">{{codeerror}}</span>
                  </div>
                </li>
              </ul>
              <ul class="form" v-if="step == 2&&type == 0">
                <li>
                  <label>手机号：</label>
                  <div class="shoujiinp">
                    <input v-model="newphone" placeholder="请输入手机号" @focus="phoneerror=''" />
                    <span class="shangxia" v-if="phoneerror!=null&&phoneerror!=''">{{phoneerror}}</span>
                  </div>
                </li>
                <li>
                  <label>验证码：</label>
                  <div class="shoujiinp">
                    <input v-model="newcode" placeholder="请输入验证码" @focus="codeerror=null" />
                    <button @click="sendMsg" type="primary" :class="[dusnhhwe == true ? 'duanxin':'duanxin2']"
                      :disabled="isDisabled">
                      <span v-if="!isDisabled">获取验证码</span>
                      <span v-if="isDisabled">重新获取 ({{time}})</span>
                    </button>
                    <span class="shangxia" v-if="codeerror!=null&&codeerror!=''">{{codeerror}}</span>
                  </div>
                </li>
              </ul>
              <ul class="form uppwd" v-if="step == 2&&type == 1">
                <li>
                  <label>新密码：</label>
                  <div class="shoujiinp ">
                    <input name="" type="password" class="text mima_dd" v-if="eyeflag" v-model="newpwd"
                      placeholder="请输入新密码" @focus="pwderror=''">
                    <input name="" type="text" class="text mima_wz" v-else v-model="newpwd"
                     placeholder="请输入新密码"  @focus="pwderror=''">
                    <a class="eyes_box " @click="eyeflag = !eyeflag"></a>
                    <span class="shangxia" v-if="pwderror!=null&&pwderror!=''">{{pwderror}}</span>
                  </div>
                </li>
                <li>
                  <label>确认密码：</label>
                  <div class="shoujiinp">
                    <input name="" type="password" class="text mima_dd" v-if="eyeflag" v-model="newpwd1"
                      placeholder="请再输入新密码"  @focus="pwderror1=''">
                    <input name="" type="text" class="text mima_wz" v-else v-model="newpwd1"
                     placeholder="请再输入新密码"  @focus="pwderror1=''">
                    <a class="eyes_box " @click="eyeflag = !eyeflag"></a>
                    <span class="shangxia" v-if="pwderror1!=null&&pwderror1!=''">{{pwderror1}}</span>
                  </div>
                </li>
              </ul>
            </div>
            <dl class="two">
              <dt @click="quxiao">取消</dt>
              <dd @click="quit">确认</dd>
            </dl>
          </div>
          <!-- <div class="annou">
            <p>您确定要退出登录吗？</p>
          </div> -->
        </div>
      </div>
    </div>

    <div class="mask" v-if="showcaozuo">
      <div class="maskA" >
        <div class="maskAA">
          <p>系统使用流程序</p>
          <img @click="showcaozuo = false" src="../../../src/assets/img/cha.png" />
        </div>
        <div class="ANAN_u">
          <figure>
            <span>1</span>
            <figcaption>绑定手机号码（必选）</figcaption>
          </figure>
          <figure>
            <span>2</span>
            <figcaption>修改密码（可选）</figcaption>
          </figure>

          <figure v-if="userInfo.userRole == '3'||userInfo.userRole == '2'">
            <span>3</span>
            <figcaption>添加学生基本资料</figcaption>
          </figure>
          <figure v-else>
            <span>3</span>
            <figcaption>完善基本资料</figcaption>
          </figure>

          <figure v-if="userInfo.userRole != '3'&&userInfo.userRole != '2'">
            <span>4</span>
            <figcaption>完善我的分数（选科和分数）（必选）</figcaption>
          </figure>

          <figure v-if="userInfo.userRole == '3'||userInfo.userRole == '2'">
            <span>4</span>
            <figcaption>选择学生开始志愿填报</figcaption>
          </figure>
          <figure v-else>
            <span>5</span>
            <figcaption>志愿填报</figcaption>
          </figure>


          <figure v-if="userInfo.userRole != '3'&&userInfo.userRole != '2'">
            <span>6</span>
            <figcaption>生成志愿单（可生成多个）</figcaption>
          </figure>
          <figure v-else>
            <span>5</span>
            <figcaption>生成志愿单（可生成多个）</figcaption>
          </figure>

        </div>
      </div>
    </div>

    <item7></item7>
  </div>
</template>

<script>
  import vHeader from '../../components/vHeader.vue'
  import item7 from '../../components/item7.vue'
  import leftmenu from '../../components/leftmenu.vue'
  import toast from '../../components/toast.vue'
  export default {
    name: "",
    components: {
      vHeader,
      item7,
      leftmenu,
      toast
    },
    data() {
      return {
        wangji: true,
        show: false,
        type: 1,
        step: 1,
        userInfo: this.$utils.getlocalStorage('userInfo'),
        title: '绑定手机',
        isDisabled: false,
        time: 60,
        dusnhhwe: true,
        oldcode: '',
        codeerror: false,
        newcode: '',
        newphone: '',
        phoneerror: '',
        newpwd:'',
        newpwd1:'',
        pwderror11:'11',
        pwderror:'11',
        pwderror1:'11',
        interval: null,
        eyeflag:true,
        showcaozuo:false

      }
    },
    created() {
      console.log('grzx_xougaimima')
      this.oldphone = this.userInfo.userPhone
      if(this.oldphone == null ||this.oldphone == ""){
        this.step = 2
        this.show = true
        this.type = 0
        this.clear();
      }
      if(this.userInfo.userName==null||this.userInfo.userName==""){
        this.showcaozuo = true;
      }
    },

    methods: {
      quxiao() {
        this.step = 1
        this.show = false
        this.clear();
        if(this.oldphone == null||this.oldphone == ''){
          this.tourl();
        }
      },
      tourl(){
        if(this.userInfo.userRole!=3&&this.userInfo.userRole!=2){
          if(this.userInfo.userProvinces!=null&&this.userInfo.userProvinces!=""&&this.userInfo.userCities!=null&&this.userInfo.userCities!=""){
            if(this.$utils.getlocalStorage('scoreInfo')!=null&&this.$utils.getlocalStorage('scoreInfo')!=""){
                if(this.type == 0){
                  this.$router.push('/xuanzheyuanhuoye')
                }
            } else {
                this.$router.push('/grzx_wdfs')
            }

          } else {
            this.$router.push('/gerenzhongxin')
          }
        } else {
          this.$router.push('/grzx_wdxs')
        }


      },
      clear(){
        this.oldcode = ''
        this.codeerror= false
        this.newcode= ''
        this.newphone=''
        this.phoneerror= ''
        this.newpwd=''
        this.newpwd1=''
        this.pwderror=''
        this.pwderror1=''
        this.interval= null
        this.eyeflag=true
      },
      updatephone() {
        this.oldphone = this.userInfo.userPhone
        if(this.oldphone == null){
          this.step = 2
        }
        this.show = true
        this.type = 0
        this.clear();

      },
      updatepwd() {
        this.oldphone = this.userInfo.userPhone
        this.show = true
        this.type = 1
        this.step = 2
        this.clear();
      },
      quit() {
        let _this = this;
        if (this.step == 1) {
          if (this.oldcode == null || this.oldcode == '') {
            this.codeerror = "请输入验证码"
            return;
          }
          _this.$req.sendoldphonecodeverification({
            code: _this.oldcode
          }).then(function(resp) {
            if (resp.status == 0) {
              _this.step = 2
              _this.dusnhhwe = true
              _this.time = 59;
              _this.isDisabled = false;
              window.clearInterval(_this.interval);
            } else {
              _this.codeerror = "验证码错误"
            }
          })
        } else if (this.step == 2) {
          if(this.type == 0){
            if (!this.$utils.regphone(this.newphone)) {
              _this.phoneerror = '请输入正确的手机号'
              return;
            }
            if(this.newcode==null||this.newcode==''){
            	_this.codeerror = "请输入验证码"
            	return;
            }
            _this.$req.sendnewphonecodeverification({code:_this.newcode,phone:_this.newphone}).then(function(resp) {
            	console.log(resp)
            	if(resp.status==0){
                _this.dusnhhwe = true
                _this.time = 59;
                _this.isDisabled = false;
                window.clearInterval(_this.interval);
            		var pat=/(\d{3})\d*(\d{4})/
            		_this.userInfo.userPhone = _this.newphone.replace(pat,'$1****$2');
            		_this.$utils.setlocalStorage("userInfo",_this.userInfo);
                _this.oldphone = _this.userInfo.userPhone
                // if(!_this.$utils.showflag(_this.userInfo.userName)){
                //   _this.$router.push('/gerenzhongxin')
                // }
                _this.tourl();
                _this.step = 1
                _this.show = false
            	}
            })
          } else if(this.type == 1){
            if(this.newpwd==null||this.newpwd==''){
            	this.pwderror = "请输入新密码"
            	return ;
            }
            if(this.newpwd1==null||this.newpwd1==''){
            	this.pwderror1 = "请再次输入新密码"
            	return ;
            }
            if(this.newpwd1!=this.newpwd){
            	this.pwderror1 = "两次输入密码不一致"
            	return ;
            }
            _this.$req.updatepwdverification({code:_this.oldcode,pwd:_this.newpwd}).then(function(resp) {
            	if(resp.status==0){
            		let userDate = _this.$utils.getlocalStorage("userDate")
                if(userDate){
                  userDate.loginPwd = ""
                  _this.$utils.setlocalStorage("userDate",userDate);
                }

                _this.$refs.leftmenu.quit();
            	}
            })
          }

        }
      },

      wangjisd(osd) {
        this.wangji = osd
      },
      sendMsg() {
        let _this = this;
        this.codeerror = ""
        if (this.step == 1) {
          this.getcode();
        } else if (this.step == 2) {
          if (!this.$utils.regphone(this.newphone)) {
            _this.phoneerror = '请输入正确的手机号'
            return;
          }
          this.getnewphonecode()
        }
        _this.dusnhhwe = false
        _this.isDisabled = true;
        this.interval = window.setInterval(function() {
          --_this.time;
          if (_this.time < 0) {
            _this.dusnhhwe = true
            _this.time = 59;
            _this.isDisabled = false;
            window.clearInterval(_this.interval);
          }

        }, 1000);
      },
      getnewphonecode() {
        //获取验证码
        let _this = this;
        if (!_this.flag) {
          _this.$req.sendonewphonecode({
            phone: _this.newphone
          }).then(function(resp) {
            console.log(resp)
            if (resp.data == '0') {
              _this.newcode = resp.str
            } else {
              _this.dusnhhwe = true
              _this.time = 59;
              _this.isDisabled = false;
              clearInterval(_this.interval)
              _this.phoneerror = resp.message
            }
          })

        }
      },
      getcode() {
        //获取验证码
        let _this = this;
        if (!_this.flag) {
          _this.$req.sendoldphonecode({}).then(function(resp) {
            console.log(resp)
            if (resp.status == 0) {
              _this.oldcode = resp.data

            }
          })

        }
      },

    }


  }
</script>

<style scoped>
  /* 遮罩层  ↓ */
  .mask {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background-color: rgba(0, 0, 0, 0.7);
  }
  .maskA {
    width: 500px;
    height: 400px;
    background: rgb(255, 255, 255);
    border-radius: 20px;
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;
  }

  .maskAA {
    width: 500px;
    height: 64px;
    background-image: url("../../assets/img/zzctop.png");
    background-size: 100% 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-right: 28px;
    padding-left: 28px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

  .maskAA img {
    width: 28px;
    height: 28px;
    cursor: pointer;
  }

  .ANAN_u {
    width: 100%;
    padding-bottom: 10px;
    padding-left: 50px;
    padding-right: 50px;
    padding-top: 20px;
    /* height: calc(100% - 170px); */

    height: 400px;
  }

  .maskAA p {
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #ffffff;
  }

  .ANAN_u figure {
    display: flex;
    margin-bottom: 18px;

  }

  .ANAN_u figure span {
    margin-right: 15px;
    background-color: #F44F25;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-size: 18px;
    border-radius: 15px;
    width: 25px;
    height: 25px;
  }

  .ANAN_u figure figcaption {
    font-size: 16px;
    /* line-height: 30px; */
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }





  .uppwd li .eyes_box{ width:45px; height:46px; position:absolute; right:0; top:0; display:block; cursor:pointer;}
  .uppwd li .mima_dd{background:#fff url(../images/yan1.jpg) no-repeat center right 15px; }
  .uppwd li .mima_wz{background:#fff url(../images/yan2.jpg) no-repeat center right 15px; }
  .upbtn {
    width: 100px !important;
    text-align: center !important;
    padding: 2px 10px;
    color: #FFFFFF !important;
    border-radius: 20px;
    margin-left: 30px;

    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);


  }

  /* 退出登录 */
  .tuichuden {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 120;
    background: rgba(0, 0, 0, 0.8);
  }

  .annou {
    display: flex;
    flex-direction: column;
    width: 500px;
    height: 300px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 20px;
    padding: 0 21px;
    box-sizing: border-box;
  }

  .annou h1 {
    width: 100%;
    height: 48px;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #29A7E1;
    opacity: 1;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  }

  .annou p {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    flex: 1;
  }

  .annou dl {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-around;
  }

  .annou dl dt {
    cursor: pointer;
    width: 140px;
    height: 40px;
    background: rgb(235 232 230);
    opacity: 1;
    border-radius: 23px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #666666;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .annou dl dd {
    cursor: pointer;
    width: 140px;
    height: 46px;
    background: linear-gradient(129deg, #F53824 0%, #F44F25 61%, #F45D26 100%);
    box-shadow: 0px 0px 10px #F53824;
    opacity: 1;
    border-radius: 24px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .wangjisdbjbsd {
    display: flex;
    flex-direction: row-reverse;
    width: 470px !important;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999 !important;
    cursor: pointer;
  }

  .biaoshu {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824 !important;
  }


  .beijngsd {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100px;
    margin-top: 70px;
    background: url(../../assets/gerenzhongxin/geren21.png)no-repeat;
    background-size: 100% 100%;
    font-size: 28px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #FFFFFF;
  }

  .beijngsd span {
    display: flex;
    width: 44px;
    height: 2px;
    opacity: 0.48;
    border-radius: 1px;
    background-color: #FFFFFF;
  }

  .beijngsd span:nth-of-type(1) {
    margin-right: 14px;
  }

  .beijngsd span:nth-of-type(2) {
    margin-left: 14px;
  }

  .centen {
    width: 1280px;
    margin: 0 auto;
  }

  .manpin {
    width: 100%;
    height: auto;
    padding: 40px 0;
    box-sizing: border-box;
    background: #ebeef5d6;
  }

  .main {
    padding-bottom: 40px;
    display: flex;
    justify-content: space-between;
  }

  .main_l {
    background: rgba(251, 251, 251, 1);
    width: 210px;
  }


  .beijngsdtu {
    background: url(../../assets/gerenzhongxin/geren26.png)no-repeat;
    background-size: 100% 100%;
  }



  .main_r {
    width: 1050px;
    height: 905px;
    background: rgba(255, 255, 255, 1);
    opacity: 1;
    border-radius: 5px;
    padding: 20px;
    box-sizing: border-box;
  }

  .mainr_top {
    width: 100%;
    height: 68px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(0, 0, 0, 0.10196078431372549);
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
  }

  .mainr_top img {
    width: 7px;
    height: 24px;
    margin-right: 10px;
  }

  .youxinxi {
    padding: 33px 20px 0 20px;
    width: 310px;
    height: 265px;
    background: rgba(251, 238, 213, 1);
    border: 1px solid #FBF5E9;
    opacity: 1;
    border-radius: 5px;
    position: absolute;
    top: -100px;
    right: 230px;
  }

  .mainr_bot {
    width: 100%;
    position: relative;
    margin-bottom: 20px;
    background-color: #ffffff;
  }

  .youxinxi label {
    position: absolute;
    top: -14px;
    left: 20px;
    width: 92px;
    height: 28px;
    background: rgba(244, 166, 65, 1);
    opacity: 1;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .youxinxi figure {
    display: flex;
    margin-bottom: 13px;
  }

  .youxinxi figure img {
    margin-right: 4px;
    width: 18px;
    height: 20px;
  }

  .youxinxi figure figcaption {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #5A4F40;
  }

  .form {
    width: auto;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    margin-left: 5px;
  }

  .form li {
    width: auto;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    position: relative;
  }

  .form li label {
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333333;
    width: 80px;
    text-align: right;
  }

  .form li i {
    color: #F53824;
    margin: 0 5px;
  }

  .form li input {
    width: 230px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #E0E0E0;
    opacity: 1;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;

  }

  .duanxin span {
    color: #FFFFFF !important;
    text-align: center;
    margin-left: 0 !important;
    margin-top: 0 !important;
    line-height: 30px;
  }

  .duanxin {
    border: none;
    position: absolute;
    top: 5px;
    left: 120px;
    width: 100px;
    height: 30px;
    background: linear-gradient(180deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .duanxin2 span {
    color: #F53824 !important;
    text-align: center;
    margin-left: 0 !important;
    margin-top: 0 !important;
    line-height: 30px;
  }

  .duanxin2 {
    border: none;
    position: absolute;
    top: 5px;
    left: 120px;
    width: 100px;
    height: 30px;
    background: rgba(238, 238, 238, 1);
    opacity: 1;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #999999;
  }

  .shoujiinp {
    width: auto;
    display: flex;
    position: relative;
  }

  .form li {
    position: static;
  }

  /* .form li .shoujiinp input{width: auto;} */
  .form li .shoujiinp span {
    margin-top: 5px;
  }

  .form li span {
    margin-left: 5px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F53824;
    opacity: 1;
  }

  .inps {
    width: 118px;
    height: 40px;
  }

  .inps:nth-of-type(1) {
    margin-right: 9px;
  }

  .inps:nth-of-type(2) {
    margin-right: 9px;
  }

  .inpda {
    width: 372px;
    height: 40px;
    background: rgba(255, 255, 255, 0.39);
    opacity: 1;
  }

  .baochuan {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 140px;
    height: 46px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }

  .baochuan2 {
    border: none;
    margin-left: 115px;
    margin-top: 20px;
    width: 324px;
    height: 52px;
    background: linear-gradient(92deg, #F53824 0%, #F45D26 100%);
    opacity: 1;
    border-radius: 23px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/j_updatepwd.vue